<template>
  <div class="mx-auto mt-5" style="max-width: 600px;">
    <div v-if="cargando" class="text-center py-5">
      <p>Cargando datos del club...</p>
    </div>

    <div v-else-if="clubExistente">
      <div class="card shadow p-4">
        <h3 class="mb-3 text-center">
          <font-awesome-icon :icon="['fas', 'users']" class="me-2" />
          Mi Club Registrado
        </h3>
        <p><strong>Nombre:</strong> {{ clubExistente.nombre }}</p>
        <p><strong>Dirección:</strong> {{ clubExistente.direccion || 'No especificada' }}</p>
        <p><strong>Descripción:</strong> {{ clubExistente.descripcion || 'Sin descripción' }}</p>
        <p><strong>Fundado:</strong> {{ clubExistente.fundacion }}</p>
      </div>
    </div>

    <div v-else class="card shadow p-4">
      <h3 class="mb-4 text-center">
        <font-awesome-icon :icon="['fas', 'users']" class="me-2" />
        Crear Nuevo Club
      </h3>

      <form @submit.prevent="submitForm">
        <div class="mb-3">
          <label class="form-label">Nombre del Club</label>
          <input v-model="club.nombre" type="text" class="form-control" required placeholder="Ej: Club Cannábico Patagonia">
        </div>

        <div class="mb-3">
          <label class="form-label">Dirección</label>
          <input v-model="club.direccion" type="text" class="form-control" placeholder="Calle Ficticia 123, Ciudad">
        </div>

        <div class="mb-3">
          <label class="form-label">Descripción</label>
          <textarea v-model="club.descripcion" class="form-control" placeholder="Breve reseña del club..."></textarea>
        </div>

        <div class="mb-3">
          <label class="form-label">Fecha de Fundación</label>
          <input v-model="club.fundacion" type="date" class="form-control">
        </div>

        <button type="submit" class="btn btn-success w-100">
          <font-awesome-icon icon="fas fa-check-circle" class="me-2" />
          Guardar Club
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from '@/axios'

export default {
  data() {
    return {
      cargando: true,
      clubExistente: null,
      club: {
        nombre: '',
        direccion: '',
        descripcion: '',
        fundacion: ''
      }
    }
  },
  mounted() {
    const hoy = new Date().toISOString().split('T')[0]
    this.club.fundacion = hoy
    this.buscarClubExistente()
  },
  methods: {
    async buscarClubExistente() {
      try {
        const user = JSON.parse(localStorage.getItem('user'))
        if (!user || !user.id) {
          console.error('No se encontró el usuario logueado.')
          return
        }
        const res = await axios.get('/api/clubes_user', {
          params: { user_id: user.id }
        })
        this.clubExistente = res.data

        //mejorar aspecto fecha
        if (this.clubExistente && this.clubExistente.fundacion) {
          const fecha = new Date(this.clubExistente.fundacion)
          this.clubExistente.fundacion = fecha.toISOString().split('T')[0]
        }
      } catch (error) {
        if (error.response?.status !== 404) {
          console.error('Error al buscar club del usuario:', error)
        }
      } finally {
        this.cargando = false
      }
    },
    async submitForm() {
      try {
        const user = JSON.parse(localStorage.getItem('user'))
        if (!user || !user.id) {
          alert('No se encontró el usuario logueado.')
          return
        }

        const clubConUsuario = {
          ...this.club,
          user_id: user.id
        }

        const response = await axios.post('/api/clubes', clubConUsuario)
        if (response.status === 200) {
          alert('Club creado con éxito')
          this.clubExistente = response.data
          this.$store.commit('setClubActual', response.data)
          this.$emit('club-creado', response.data)
        }
      } catch (error) {
        console.error('Error al crear el club:', error)

      }
    }
  }
}
</script>

<style scoped>
.card {
  background-color: #fff;
  border-radius: 12px;
}
</style>
